import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TransactionsSyncFiltering, RegularCollectionPointAddEdit } from './Pages';

export const TransactionsSyncRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TransactionsSyncFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={RegularCollectionPointAddEdit} />
    </Fragment>
)